import React, { useMemo, useState, useEffect } from 'react';
import styled from 'styled-components';
import { throttle } from 'lodash';

import RegisterForm from '../components/register/organisms/RegisterForm';
import Navigation from '../components/commons/organisms/Navigation';
import APIService from '../utils/api';
import { SOFT_TOMATO } from '../components/colors';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import usePageView from '../hooks/use-page-view';
import { MIXPANEL_ACTION, MIXPANEL_PAGE } from '../utils/constants';
import MixpanelService from '../utils/mixpanel';

interface RegisterProps {

}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;

  @media(min-width: 768px) {
    max-width: 1200px; /* or 1280px */
    margin: 0 auto;
    padding: 1rem 1rem; /* optional side padding */
    flex-direction: row-reverse;
  }
`;

const Title = styled.div`
  p {
    font-family: 'Poppins-SemiBold';
    font-size: 1rem;
    margin: 0 0;
  }
`;

const Subtitle = styled.div`
  p {
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    margin: 0 0;
  }
`;

const LeftPane = styled.div`
  // border: 1px solid red;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
 

const RightPane = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const BigLogo = styled.div`
  height: 180px;
  img {
    height: 180px;
    object-fit: cover;
  }
`;

const ErrorLabel = styled.div`
  p {
    font-family: 'Poppins-SemiBold';
    font-size: 0.8rem;
    margin: 0 0;
    color: red;
    margin-top: 1rem;
  }
`;

const ButtonLogin = styled.div`
  p {
    text-align: center;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    text-decoration: underline;
    color: ${SOFT_TOMATO}
  }
`;

const Register = () => {

  const navigate = useNavigate();
  const [registerError, setRegisterError] = useState<string | null>();
  const {
    user
  } = useAuth();

  usePageView(MIXPANEL_PAGE.REGISTER);

  const registerCustomer = async (payload: any) => {
    try {
      const data = await APIService.register(payload);
    } catch (e: any) {
      switch (e.status) {
        case 409: 
          setRegisterError('An account with this email already exists'.toUpperCase());
          break;
        default:
          setRegisterError('UNKNOWN ERROR OCCURED')
      }
    }
  }

  const throttleOnSubmit = useMemo(() => throttle((payload: any) => {
    registerCustomer(payload)
  }, 2000), []); 

  useEffect(() => {
    if (user) {
      navigate('/shop')
    }
  }, [user])
  
  return (
    <>
      <Navigation />
      <Container>
        <LeftPane>
          <BigLogo>
            <img src={require('../assets/hg-logo.png')} />
          </BigLogo>       
        </LeftPane>
        <RightPane>
          <Title>
            <p>{'Sign Up'.toUpperCase()}</p>
          </Title>
          <Subtitle>
            <p>{'Create your account to enjoy a faster, easier shopping experience.'.toUpperCase()}</p>
          </Subtitle>
          { registerError && 
            <ErrorLabel>
              <p>
                {registerError}
              </p>
            </ErrorLabel>
          }
          <RegisterForm
            onSubmit={(email, password) => {
               MixpanelService.track(
                `${MIXPANEL_PAGE.LOGIN} - ${MIXPANEL_ACTION.BUTTON_CLICK}`, {
                  item: 'Register',
                }
              );
              throttleOnSubmit({
                email,
                password
              })
            }}
          />
          <ButtonLogin>
            <p  onClick={() => {
               MixpanelService.track(
                `${MIXPANEL_PAGE.LOGIN} - ${MIXPANEL_ACTION.BUTTON_CLICK}`, {
                  item: 'Login',
                }
              );
              navigate('/login');
            }}
            >
              ALREADY HAVE AN ACCOUNT? LOGIN
            </p>
          </ButtonLogin>
        </RightPane>
      </Container>
    </>
  )
}

export default Register;